import { Component, ViewChild, TemplateRef, Renderer2, OnInit, OnChanges, OnDestroy, AfterViewInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { messageService } from 'src/app/message.service';
import { qmsService } from '../qms.service';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { TaskActionsHistoryComponent } from '../task-actions-history/task-actions-history.component';
import { SwitchuserComponent } from 'src/app/support/switchuser/switchuser.component';
import { TopNavigationComponent } from 'src/app/top-navigation/top-navigation.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { MatTabGroup } from '@angular/material/tabs';
import { ModuletypeComponent } from 'src/app/moduletype/moduletype.component';
import { DependencyNavigationService } from 'src/app/support/navigation/dependency-navigation.service';
import { FlexibleFieldsComponent } from '../flexible-fields/flexible-fields.component';
import { QualityDependentsComponent } from '../quality-dependents/quality-dependents.component';

@Component({
  selector: 'app-in',
  templateUrl: './in.component.html',
  styleUrls: ['./in.component.scss']
})

export class InComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {

  infoIconSrc: string = '../../assets/img/info-yellow.png';

  isProcessing: boolean = false;
  dateCustomClasses: DatepickerDateCustomClasses[];
  incidentData: any = {};
  isDetailSectionFrozen: boolean = false;
  isDateSectionFrozen: boolean = false;
  isLoggingSectionFrozen: boolean = false;
  isInvestigationSectionFrozen: boolean = false;
  isCompleteSectionFrozen: boolean = false;
  elite_Action_EC_Risk: boolean = false; /* Exclusive privilege to edit action and risk toggle buttons */
  pdfDetailSearchText: string = '';
  dropDownDataForReportTemplate: any;
  selectedReportTemplateValue: any = null;
  reportTemplateDropdown: any = [];
  skipValidationsWhileSwitchingUser: boolean = false;
  isStageUsersSkipped: boolean = false;
  isAdditionalTabUser: boolean = false;
  attachAllDocuments: boolean = false;
  constructor(
    public dialog: MatDialog,
    public router: Router,
    public message: messageService,
    public qmsService: qmsService,
    public taskActionsHistoryComponent: TaskActionsHistoryComponent,
    private readonly snackBar: MatSnackBar,
    private readonly renderer: Renderer2,
    private readonly appService: AppService,
    public dependencyNavigationService: DependencyNavigationService,
  ) {
    const now = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];

    this.isAdditionalTabUser = this.qmsService?.userRole[0]?.qmsRoles?.includes("Additional Tab User");
    Object.keys(this.qmsService.incidentDropDowns).forEach(key => {
      if (key === 'selectedRootCauseType' || key === 'selectedBusinessArea') {
        this.qmsService.incidentDropDowns[key] = [];
      } else {
        this.qmsService.incidentDropDowns[key] = null;
      }
    })

    this.appService.getTaskStages(qmsService.activityId, 0).subscribe((stageUser: any) => {
      this.isStageUsersSkipped = !stageUser.length;
    })
  }

  @ViewChild(TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  @ViewChild(QualityDependentsComponent) dependentsComp!: QualityDependentsComponent;
  public openDependentsPopup(): void {
    this.dependentsComp.openPopup();
  }
  openGroupMethod() { this.topNavigationComponent.opengroupPopup(); }

  dropDownForDepartmentCode: any = [];
  dropDownForIncidentType: any = [];
  filteredRequestedAt: any = [];
  dropDownForRequestedAt: any = [];
  dropDownForCoreBusinessArea: any = [];
  dropDownForCoreBusinessAreaName: any = [];
  dropDownForInitiatedOnBehalf: any = [];
  dropDownDataForImpactType: any = [];
  dropDownForIncidentReference: any = [];
  dropDownForEvaluator: any = [];
  dropDownForEvaluationResult: any = [];
  dropDownForEvaluationRejectReason: any = [];
  dropDownForInvestigator: any = [];
  dropDownForRootCauseType: any = [];
  dropDownForResolutionCategory: any = [];

  departmentCodeDropdown: any = [];
  incidentTypeDropdown: any = [];
  requestedAtDropdown: any = [];
  coreBusinessAreaNameDropdown: any = [];
  initiatedOnBehalfDropDown: any = [];
  impactTypeDropdown: any = [];
  incidentReferenceDropdown: any = [];
  evaluatorDropDown: any = [];
  evaluationResultDropDown: any = [];
  evaluationRejectReasonDropDown: any = [];
  investigatorDropDown: any = [];
  rootCauseTypeDropDown: any = [];
  resolutionCategoryDropDown: any = [];

  groupSearchText: string = '';
  typeSearchText: string = '';
  departmentSearchText: string = '';
  requestedSearchText: string = '';
  coreBusinessSearchText: string = '';
  referenceSearchText: string = '';
  behalfOfSearchText: string = '';
  impactTypeSearchText: string = '';
  evaluatorSearchText: string = '';
  investigatorSearchText: string = '';
  rootCauseSearchText: string = '';
  resolutionSearchText: string = '';

  oddGroup: any = null;
  oddType: any = null;
  oddDepartment: any = null;
  oddRequestedAt: any = null;
  oddReference: any = null;
  oddImpactType: any = null;
  oddEvaluator: any = null;
  oddInvestigator: any = null;
  oddResolution: any = null;

  coreBusinessAreaFieldValue: any;
  businessAreaName: any;
  requestedAtFieldValue: any;
  isForVendor: boolean;
  visibleReferenceIfOthers: boolean;

  stageName: any;
  actionStatusOptions: any;
  instructions = "";
  buttonLabels: string[] = [];
  saveButtonForTraining: boolean = false;
  objForDocuments: any;

  focusSearch(value: any) {
    setTimeout(() => { let searchBox = document.getElementById(value); searchBox?.focus(); }, 0)
  }

  getColor(status: any) {
    if (status != undefined && status != "") {
      if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
        return 'red';
      } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
        return 'orange';
      } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
        return 'green';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  statusAppearance(status: string) {
    if (!status) {
      return null;
    }

    let color = '#0f3659';
    let background = '';
    let border = '0.75px solid #0f3659';

    if (status.includes('Rejected') || status.includes('Deleted') || status.includes('Obsoleted')) {
      color = '#FF3A29';
      background = '#FF3A291A';
      border = '0.75px solid #FF3A29';
    } else if (status.includes('Open') || status.includes('Draft') || status.includes('Scheduled') || status.includes('Initiated')) {
      color = '#FF8900';
      background = '#FF89001A';
      border = '0.75px solid #FF8900';
    } else if (status.includes('Closed') || status.includes('Completed') || status.includes('Approved')) {
      color = '#00E58F';
      background = '#00E58F1A';
      border = '0.75px solid #00E58F';
    } else if (status.includes('QA Accepted') || status.includes('Owner Acknowledged') || status.includes('Pending Closure Approval') ||
      status.includes('In Progress') || status.includes('Pending Closure Review') || status.includes('Pending QA Acceptance') ||
      status.includes('Pending Obsolete Approval')) {
      background = '#005C8A1A';
      border = '0.75px solid #005C8A1A';
    }

    return {
      color,
      background,
      border,
      'font-family': 'Poppins',
      'border-radius': '6px',
      'padding': '3px 9px',
      'font-size': '16px !important',
      'font-style': 'normal',
      'font-weight': '500',
      'line-height': '15px'
    };
  }

  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit() {
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);

    this.initiate();

    this.dependencyNavigationService.refresh.subscribe(() => {
      if (this.qmsService.moduleName == 'IN') {
        this.initiate();
      }
    });
  }


  private initiate(): void {
    this.selectedTabIndex = 0;
    this.ngOnChangesReportFooter();
    this.isProcessing = true;
    this.loadMainCall();
    this.getDynamicLabel();

  }

  label: any = [];
  dynamicLabel: any = null;
  getDynamicLabel() {
    this.isProcessing = true;
    const data = {
      tableName: 'QMS_IN_GRID_VW',
      moduleName: 'IN',
      gridName: 'IN',
      groupId: this.qmsService.selectedGroup,
      forLabel: "Y"
    };

    this.appService.getreorderGirdColumnList(data).subscribe({
      next: (labelResponse: any) => {
        this.label = labelResponse;
        this.dynamicLabel = this.label.reduce((acc: any, user: any) => {
          acc[`${user.columnName}`] = {
            fieldName: user.changedFieldName,
            isRemovable: user.isFieldRemovable,
            fieldNotes: user.fieldNotes
          };
          this.qmsService.activityDynamicLabel = acc;
          return acc;
        }, {});
        this.isProcessing = false;
      }, error: (error: any) => {
        this.isProcessing = false;
        throw error;
      }
    });
  }

  loadMainCall() {
    this.isProcessing = true;

    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') ?? '{}');
    this.objForDocuments = {
      id: this.qmsService.activityId,
      pagename: "Activity"
    };
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

    const groupId = this.qmsService.selectedActivityGroupId;
    const groupDetailId = this.qmsService.selectedGroupDetailData.groupDetailId;
    const moduleName = this.qmsService.moduleName;
    const getQmsBusinessAreaDetails$ = this.appService.getAllQmsBusinessAreas();
    const getCodeListsByImpactType$ = this.appService.getCodeListsByGroup("INCIDENT_IMPACT_TYPE");
    const getCodeListsByIncidentReference$ = this.appService.getCodeListsByGroup("INCIDENT_REFERENCE");
    const getCodeListByRootCauseType$ = this.appService.getCodeListsByGroup("ROOT_CAUSE_TYPE");
    const getCodeListByResolutionCategory$ = this.appService.getCodeListsByGroup("INCIDENT_RESOLUTION_CATEGORY");
    const getEvaluators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Evaluator");
    const getInvestigators$ = this.appService.getQmsActiveGroupUsers(groupId, moduleName, "Investigator");
    const getTypeSettings$ = this.appService.getTypeSettingsByGrpIdGrpDetailId(groupId, groupDetailId);
    const getReportTemplate$ = this.appService.getQmsReportTemplateDetailsByModuleAndGroupId(moduleName, this.qmsService.selectedGroup);
    const getOrgReportImage$ = this.appService.getOneQmsOrganizationReportImage();
    const getQmsReportLogo$ = this.appService.getQmsReportLogoByModuleAndGroupId("QMS", this.qmsService.selectedGroup)

    forkJoin([
      getQmsBusinessAreaDetails$,
      getCodeListsByImpactType$,
      getCodeListsByIncidentReference$,
      getCodeListByRootCauseType$,
      getCodeListByResolutionCategory$,
      getEvaluators$,
      getInvestigators$,
      getTypeSettings$,
      getReportTemplate$,
      getOrgReportImage$,
      getQmsReportLogo$
    ]).pipe(
      switchMap(([businessAreaData, impactTypeData, incidentReferenceData, rootCauseTypeData, resolutionCategoryData, evaluatorData, investigatorData, typeSettings, getReportTemplate, orgReportImage, qmsReportLogo]) => {
        this.filteredRequestedAt = businessAreaData;
        this.dropDownForRequestedAt = this.filteredRequestedAt.filter((item: any) => item.module === this.qmsService.moduleName);

        this.dropDownDataForImpactType = impactTypeData;
        this.selectBoxForImpactType();

        this.dropDownForIncidentReference = incidentReferenceData;
        this.selectBoxForIncidentReference();

        this.dropDownForRootCauseType = rootCauseTypeData;
        this.selectBoxForRootCauseType();

        this.dropDownForResolutionCategory = resolutionCategoryData;
        this.selectBoxForResolutionCategory();

        this.dropDownForEvaluator = evaluatorData;
        this.selectBoxForEvaluator();

        this.dropDownForInvestigator = investigatorData;
        this.selectBoxForInvestigator();

        this.dropDownForIncidentType = typeSettings;
        this.selectBoxForIncidentType();

        this.dropDownDataForReportTemplate = getReportTemplate;
        this.selectBoxForReportTemplate();

        this.organizationReportImageDetails = orgReportImage;

        this.dropDownDataForReportLogo = qmsReportLogo;
        this.selectBoxForReportLogo();

        return this.appService.getIncidentDetailsByInNo(this.qmsService.activityId);
      })
    ).subscribe(incidentDetails => {

      this.incidentData = incidentDetails;
      if (this.incidentData.status === 'Closed') this.checkEcHasData();
      else this.message.showEffectiveSection = false;

      this.qmsService.activity = incidentDetails;
      this.parallelWorkflowList = [];
      this.appService.getWorkflowByRefNo(this.qmsService.activityId).subscribe((data: any) => {
        this.parallelWorkflowList = data;
      });
      this.selectBoxForDepartment();
      this.selectBoxForRequestedAt();

      this.qmsService.activity.createdOn = new Date(this.incidentData.createdOn);
      this.qmsService.activity.identifiedOn = new Date(this.incidentData.identifiedOn);
      this.qmsService.activity.expectedToBeStartedOn = new Date(this.incidentData.expectedToBeStartedOn);
      this.qmsService.activity.expcetedClosureOn = new Date(this.incidentData.expcetedClosureOn);
      this.qmsService.activity.startedOn = this.incidentData.startedOn ? new Date(this.incidentData.startedOn) : null;
      this.qmsService.activity.lastActionOn = this.incidentData.lastActionOn ? new Date(this.incidentData.lastActionOn) : null;
      this.qmsService.activity.groupReassignedOn = this.incidentData.groupReassignedOn ? new Date(this.incidentData.groupReassignedOn) : null;
      this.qmsService.activity.completedOn = this.incidentData.completedOn ? new Date(this.incidentData.completedOn) : null;

      this.qmsService.activity.isOutsideOrganization = this.incidentData.isOutsideOrganization == "Y";
      this.qmsService.activity.investigationRequired = this.incidentData.investigationRequired == "Y";
      this.qmsService.activity.actionItemsReqd = this.incidentData.actionItemsReqd == "Y";
      this.qmsService.activity.preActionItemsReqd = this.incidentData.preActionItemsReqd == "Y";
      this.qmsService.activity.usersToBeIntimatedPostEvaluation = this.incidentData.usersToBeIntimatedPostEvaluation == "Y";
      this.qmsService.activity.isRiskCalculationReqd = this.incidentData.isRiskCalculationReqd == "Y";
      this.qmsService.activity.effectivenessCheckReqd = this.incidentData.effectivenessCheckReqd == "Y";
      this.message.showActionSection = this.incidentData.actionItemsReqd;

      this.getDynamicButtons();
      this.setDropdowns();
      this.getStageUsers();
      this.ngOnChanges();

      this.isProcessing = false;
      this.activityData = false;
    });
  };

  setDropdowns() {

    const matchingDepartment = this.dropDownForDepartmentCode?.find((item: any) => item.codelistCode === this.incidentData.deptCode);
    if (!matchingDepartment) {
      this.oddDepartment = this.incidentData.deptCode;
      this.departmentCodeDropdown.push({
        valueExp: this.incidentData.deptCode,
        displayExp: this.incidentData.deptCode
      })
    }
    this.qmsService.incidentDropDowns.selectedDepartment = this.incidentData.deptCode;

    const matchingIncidentType = this.dropDownForIncidentType?.find((item: any) => item.type === this.incidentData.inType);
    if (!matchingIncidentType) {
      this.oddType = this.incidentData.inType;
      this.incidentTypeDropdown.push({
        valueExp: this.incidentData.inType,
        displayExp: this.incidentData.inType
      })
    }
    this.qmsService.incidentDropDowns.selectedIncidentType = this.incidentData.inType;

    const matchingReference = this.dropDownForIncidentReference?.find((item: any) => item.codelistCode === this.incidentData.reference);
    if (!matchingReference) {
      this.oddReference = this.incidentData.reference;
      this.incidentReferenceDropdown.push({
        valueExp: this.incidentData.reference,
        displayExp: this.incidentData.reference
      })
    }
    this.visibleReferenceIfOthers = this.incidentData.reference?.toLowerCase() == 'others';
    this.qmsService.incidentDropDowns.selectedReference = this.incidentData.reference;

    const matchingRequestedAt = this.dropDownForRequestedAt?.find((item: any) => item.taskRequestedAt === this.incidentData.requestedAt);
    if (!matchingRequestedAt) {
      this.oddRequestedAt = this.incidentData.requestedAt;
      this.requestedAtDropdown.push({
        valueExp: this.incidentData.requestedAt,
        displayExp: this.incidentData.requestedAt
      })
    }

    this.qmsService.incidentDropDowns.selectedRequestedAt = this.businessAreaName = this.incidentData.requestedAt;

    setTimeout(() => {
      const selectedBusinessArea = this.isBusinessAreaEmpty ? this.incidentData.coreBusinessAreaName : this.incidentData.coreBusinessAreaName?.split(',') ?? [];
      this.qmsService.incidentDropDowns.selectedBusinessArea = selectedBusinessArea;

      if (!this.isBusinessAreaEmpty) this.isAllBusinessAreaSelected = this.qmsService.incidentDropDowns.selectedBusinessArea.length == this.coreBusinessAreaNameDropdown.length;
    }, 1500);

    if (this.incidentData.initiatedOnBehalf) {
      this.qmsService.activity.initiatedOnBehalfByOthers = true;
      let apiCallObservable;

      if (this.qmsService.activity.isOutsideOrganization) {
        this.isForVendor = true;
        apiCallObservable = this.appService.getQmsVendorsVwDetails();
      } else {
        this.isForVendor = false;
        apiCallObservable = this.appService.getModuleBasedPrivilegedUsersList('QMS');
      }

      apiCallObservable.subscribe((data: any) => {
        this.dropDownForInitiatedOnBehalf = data;
        this.selectBehalfOfUsers();
        this.handleBehalfDropdown();
      })
    } else {
      this.qmsService.activity.initiatedOnBehalfByOthers = false;
      this.appService.getModuleBasedPrivilegedUsersList('QMS').subscribe((data: any) => {
        this.dropDownForInitiatedOnBehalf = data;
        this.selectBehalfOfUsers();
      })
    }

    const matchingImpactType = this.dropDownDataForImpactType?.find((item: any) => item.codelistCode === this.incidentData.impactType);
    if (!matchingImpactType) {
      this.oddImpactType = this.incidentData.impactType;
      this.impactTypeDropdown.push({
        valueExp: this.incidentData.impactType,
        displayExp: this.incidentData.impactType
      })
    }
    this.qmsService.incidentDropDowns.selectedImpactType = this.incidentData.impactType;

    if (this.incidentData.evaluator) {
      const matchingEvaluator = this.dropDownForEvaluator?.find((item: any) => item.userId === this.incidentData.evaluator);
      if (!matchingEvaluator) {
        this.oddEvaluator = this.incidentData.evaluator;
        this.evaluatorDropDown.push({
          valueExp: this.incidentData.evaluator,
          displayExp: this.incidentData.evaluatorUser
        })
      }
      this.qmsService.incidentDropDowns.selectedEvaluator = this.incidentData.evaluator;
    }

    if (this.incidentData.investigator) {
      const matchingInvestigator = this.dropDownForInvestigator?.find((item: any) => item.userId === this.incidentData.investigator);
      if (!matchingInvestigator) {
        this.oddInvestigator = this.incidentData.investigator;
        this.investigatorDropDown.push({
          valueExp: this.incidentData.investigator,
          displayExp: this.incidentData.investigatorUser
        })
      }
      this.qmsService.incidentDropDowns.selectedInvestigator = this.incidentData.investigator;
    }

    if (this.incidentData.rootCauseType) {
      this.qmsService.incidentDropDowns.selectedRootCauseType = this.incidentData.rootCauseType.split(',');
    }

    if (this.incidentData.resolutionCategory) {
      const matchingResolutionCategory = this.dropDownForResolutionCategory?.find((item: any) => item.codelistCode === this.incidentData.resolutionCategory);
      if (!matchingResolutionCategory) {
        this.oddResolution = this.incidentData.resolutionCategory;
        this.resolutionCategoryDropDown.push({
          valueExp: this.incidentData.resolutionCategory,
          displayExp: this.incidentData.resolutionCategory
        })
      }
      this.qmsService.incidentDropDowns.selectedResolutionCategory = this.incidentData.resolutionCategory
    }
  }

  getDynamicButtons() {
    let data1 = {
      activityId: this.message.activityId,
      moduleName: this.qmsService.moduleName,
      status: this.incidentData.status
    }
    this.appService.getQmsButtons(data1).subscribe((data: any) => {
      console.log('DYNAMIC BUTTONS → ', data);
      this.qmsService.activityDynamicButtonList = [];
      this.buttonLabels = [];
      this.qmsService.activitySaveButton = false;
      if (data.resultType == "S") {
        this.qmsService.showflexifieldshow = false;
        this.stageName = data.stageName;
        this.actionStatusOptions = data.actionStatusOptions;
        this.instructions = data.instructions;
        this.qmsService.activityButtonLabels = data;
        if (data.buttonLabels) {
          this.buttonLabels = data.buttonLabels.split(",");
          this.buttonLabels.unshift("Cancel");
          this.qmsService.activityDynamicButtonList = this.buttonLabels;
          console.log('DYNAMIC BUTTONS LIST→ ', this.qmsService.activityDynamicButtonList);
          for (const element of this.buttonLabels) {
            if (element.includes("Submit") || element.includes("Review") || element.includes("Approv") || element.includes("Accept")) {
              this.qmsService.showflexifieldshow = true;
            }
            if (element == "Save") {
              this.saveButtonForTraining = true;
              this.qmsService.activitySaveButton = true;
            }
          }
        } else {
          this.buttonLabels.unshift("Cancel");
          this.qmsService.activityDynamicButtonList = this.buttonLabels;
        }
      } else {
        this.buttonLabels.unshift("Cancel");
        this.qmsService.activityDynamicButtonList = this.buttonLabels;
      }
      if (data.resultType != "S") {
        this.showSnackBar(data.result, data.resultType);
      }
    })
  }

  ngOnChanges() {
    this.qmsService.refereshBreadCrumb = true;
  }

  selectedTab: any;
  selectedTabIndex: any;
  tabIndex: number = 0;
  onTabChanged($event: any) {
    this.selectedTab = $event.tab.textLabel;
    this.tabIndex = $event.index;
    this.qmsService.selectedTabName = $event.tab.textLabel;

    this.setIncidentAesthetic();
  }

  private readonly model: {
    documents: any[];
    action: any[];
    preAction: any[],
    stagesUser: any[];
    extension: any[];
    effectiveness: any[];
    dependency: any[];
    parallelWorkFlow: any[];
  } = {
      documents: [],
      action: [],
      preAction: [],
      stagesUser: [],
      extension: [],
      effectiveness: [],
      dependency: [],
      parallelWorkFlow: [],
    };

  public on_documents_emit($event: any): void {
    this.model.action = $event.action;
  }

  public on_action_emit($event: any): void {
    this.model.documents = $event.documents;
  }

  public on_preAction_emit($event: any): void {
    this.model.preAction = $event.preAction;
  }

  public on_stageUser_emit($event: any): void {
    this.model.stagesUser = $event.stages;
  }

  public on_extension_emit($event: { $extension: any[], $destroying?: boolean }): void {
    if ($event?.$destroying) {
      this.appService.getIncidentDetailsByInNo(this.qmsService.activityId).subscribe((incident: any) => {
        this.incidentData.expcetedClosureOn = this.qmsService.activity.expcetedClosureOn = new Date(incident.expcetedClosureOn);
      })
    }

    this.model.extension = $event.$extension;
  }

  public on_effectiveness_emit($event: any): void {
    this.model.effectiveness = $event.effectiveness;
  }

  public on_dependency_emit($event: any): void {
    this.model.dependency = $event.dependency;
  }

  public on_parallelWorkFlow_emit($event: any): void {
    this.model.parallelWorkFlow = $event.parallelWorkFlow;
  }

  handleBehalfDropdown() {
    this.qmsService.incidentDropDowns.selectedBehalfOfOthers = this.incidentData.initiatedOnBehalf;
  }

  selectBoxForIncidentType() {
    this.incidentTypeDropdown = [];
    this.incidentTypeDropdown = this.dropDownForIncidentType?.map((item: any) => ({
      valueExp: item.type,
      displayExp: item.type
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onIncidentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('in-type-validation', item);
      if (item) {
        this.isProcessing = true;
        this.appService.getTypeSettingsByType(this.qmsService.selectedActivityGroupId, this.qmsService.selectedGroupDetailId, item.valueExp).subscribe((response: any) => {
          if (response.toBeStartedInDays) {
            let date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setDate(date.getDate() + response.toBeStartedInDays);
            this.qmsService.activity.expectedToBeStartedOn = date;
            this.onNgModelChange(this.qmsService.activity.expectedToBeStartedOn, 'expected-to-be-started-on-validation');
          }
          if (response.toBeClosedInDays) {
            let date = new Date();
            date.setHours(12);
            date.setMinutes(0);
            date.setSeconds(0);
            this.qmsService.activity.expectedToBeStartedOn == null ? date.setDate(date.getDate() + response.toBeClosedInDays) : date.setDate(date.getDate() + response.toBeStartedInDays + response.toBeClosedInDays);
            this.qmsService.activity.expcetedClosureOn = date;
            this.onNgModelChange(this.qmsService.activity.expcetedClosureOn, 'expected-closure-on-validation');
          }
          this.isProcessing = false;
        })
      }
    }
  }

  selectBoxForDepartment() {
    this.departmentCodeDropdown = [];
    this.departmentCodeDropdown = this.dropDownForDepartmentCode?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onDepartmentSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('department-validation', item);
  }

  selectBoxForIncidentReference() {
    this.incidentReferenceDropdown = [];
    this.incidentReferenceDropdown = this.dropDownForIncidentReference?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  onReferenceSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('reference-validation', item);
      if (item) {
        if (item.displayExp == 'Others') [this.visibleReferenceIfOthers, this.qmsService.activity.referenceOthers] = [true, ''];
        else this.visibleReferenceIfOthers = false;
      }
    }
  }

  selectBoxForRequestedAt() {
    this.requestedAtDropdown = [];
    this.requestedAtDropdown = this.dropDownForRequestedAt?.map((item: any) => ({
      valueExp: item.taskRequestedAt,
      displayExp: item.taskRequestedAt.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []

    const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == this.incidentData.requestedAt);
    this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;

    if (!this.isBusinessAreaEmpty) {
      this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
      this.selectBoxForCoreBusinessAreaName();
    }
  }

  activityData: boolean;
  isBusinessAreaEmpty: boolean = false;
  @ViewChild('flexible') flexibleComponent!: FlexibleFieldsComponent;
  onRequestedAtSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.handleDropDownValidation('requestedAt-validation', item);
      if (item) {
        this.businessAreaName = item.displayExp;

        const businessArea = this.dropDownForRequestedAt.find((task: any) => task.taskRequestedAt == item.displayExp);
        this.isBusinessAreaEmpty = businessArea ? !businessArea.listOfBusinessArea : true;
        [this.coreBusinessAreaNameDropdown, this.qmsService.incidentDropDowns.selectedBusinessArea] = [[], this.isBusinessAreaEmpty ? '' : []];

        if (!this.isBusinessAreaEmpty) {
          this.isAllBusinessAreaSelected = false;
          this.dropDownForCoreBusinessArea = businessArea.listOfBusinessArea?.split(',');
          this.selectBoxForCoreBusinessAreaName();
        }

        setTimeout(() => { this.flexibleComponent.triggerFromRequestedAt(item.valueExp) });
      }
    }
  }

  selectBoxForCoreBusinessAreaName() {
    this.coreBusinessAreaNameDropdown = [];
    this.coreBusinessAreaNameDropdown = this.dropDownForCoreBusinessArea?.map((value: any) => ({
      valueExp: value,
      displayExp: value.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp)) ?? []
  }

  @ViewChild('businessArea') businessArea: MatSelect;
  isAllBusinessAreaSelected = false;
  @ViewChild('rootCause') rootCause: MatSelect;
  isAllRootCauseSelected = false;

  toggleAllSelection(value: any) {
    if (value == 'businessArea') {
      if (this.isAllBusinessAreaSelected) this.businessArea.options.forEach((item: MatOption) => item.select());
      else {
        this.businessArea.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.incidentDropDowns.selectedBusinessArea = [];
      }

      setTimeout(() => {
        this.handleDropDownValidation('business-area-validation', this.qmsService.incidentDropDowns.selectedBusinessArea)
      });

    } else if (value == 'rootCause') {
      if (this.isAllRootCauseSelected) this.rootCause.options.forEach((item: MatOption) => item.select());
      else {
        this.rootCause.options.forEach((item: MatOption) => item.deselect())
        this.qmsService.incidentDropDowns.selectedRootCauseType = [];
      }

      setTimeout(() => {
        this.handleDropDownValidation('root-cause-type-validation', this.qmsService.incidentDropDowns.selectedRootCauseType)
      });
    }
  }

  onCoreBusinessAreaNameSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('business-area-validation', this.qmsService.incidentDropDowns.selectedBusinessArea);
        this.isAllBusinessAreaSelected = this.coreBusinessAreaNameDropdown.length == this.qmsService.incidentDropDowns.selectedBusinessArea.length;
      })
  }

  selectBehalfOfUsers() {
    this.initiatedOnBehalfDropDown = this.dropDownForInitiatedOnBehalf.map((item: any) => ({
      valueExp: this.isForVendor ? item.vendorId : item.userId,
      displayExp: this.isForVendor ? item.vendorName.trim() : item.userName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  onBehalfOfOthersSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('behalf-of-others-validation', item);
  }

  selectBoxForImpactType() {
    this.impactTypeDropdown = [];
    this.impactTypeDropdown = this.dropDownDataForImpactType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  onImpactTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('impact-type-validation', item);
  }

  selectBoxForEvaluator() {
    this.evaluatorDropDown = [];
    this.evaluatorDropDown = this.dropDownForEvaluator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  selectBoxForInvestigator() {
    this.investigatorDropDown = [];
    this.investigatorDropDown = this.dropDownForInvestigator?.map((item: any) => ({
      valueExp: item.userId,
      displayExp: item.userName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  onInvestigatorSelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('investigator-validation', item);
  }

  selectBoxForRootCauseType() {
    this.rootCauseTypeDropDown = [];
    this.rootCauseTypeDropDown = this.dropDownForRootCauseType?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  onRootCauseTypeSelect(event: any, item: any) {
    if (event.isUserInput)
      setTimeout(() => {
        this.handleDropDownValidation('root-cause-type-validation', this.qmsService.incidentDropDowns.selectedRootCauseType);
        this.isAllRootCauseSelected = this.rootCauseTypeDropDown.length == this.qmsService.incidentDropDowns.selectedRootCauseType.length;
      })
  }

  selectBoxForResolutionCategory() {
    this.resolutionCategoryDropDown = [];
    this.resolutionCategoryDropDown = this.dropDownForResolutionCategory?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName.trim()
    })).sort((m: { displayExp: string }, n: { displayExp: string }) => m.displayExp.localeCompare(n.displayExp));
  }

  onResolutionCategorySelect(event: any, item: any) {
    if (event.isUserInput)
      this.handleDropDownValidation('resolution-category-validation', item);
  }

  onIsOutsideOrganizationChange(event: any) {
    this.isProcessing = true;
    this.isForVendor = event.checked;
    this.qmsService.incidentDropDowns.selectedBehalfOfOthers = null;

    const apiCall = this.isForVendor ? this.appService.getQmsVendorsVwDetails() : this.appService.getModuleBasedPrivilegedUsersList('QMS');

    apiCall.subscribe((data: any) => {
      this.dropDownForInitiatedOnBehalf = data;
      this.selectBehalfOfUsers();
      this.isProcessing = false;
    });
  }

  onInitiatedOnBehalfByChange() {
    this.qmsService.activity.isOutsideOrganization = false;
    this.qmsService.incidentDropDowns.selectedBehalfOfOthers = null;
  }

  onInvestigationRequiredChange() {
    this.qmsService.incidentDropDowns.selectedInvestigator = null;
  }

  @ViewChild('editor', { static: true }) editor: TemplateRef<any>;
  visibleEditor: MatDialogRef<TemplateRef<any>>;

  editorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  dateTimePickerConfiguration = {
    dateInputFormat: 'DD-MMM-YYYY HH:mm:ss',
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
  };
  dateFormat: any = this.message.organizationDetails?.dateFormat ?? 'DD-MMM-YYYY';
  commonDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
  }

  identifiedOnConfig = {
    ...this.commonDateConfig,
    maxDate: new Date()
  }

  expectedToBeStartedOnConfig = {
    ...this.commonDateConfig,
    minDate: new Date()
  }

  dateTimeConfig = {
    ...this.commonDateConfig,
    dateInputFormat: this.dateFormat + ' HH:mm:ss'
  }

  onExpectedToBeStartedOnChange() {
    if (this.qmsService.activity.expcetedClosureOn && (this.qmsService.activity.expcetedClosureOn < this.qmsService.activity.expectedToBeStartedOn)) this.qmsService.activity.expcetedClosureOn = null;
  }

  generateExpectedClosureDateConfig() {
    return {
      ...this.commonDateConfig,
      minDate: this.qmsService.activity.expectedToBeStartedOn ? new Date(this.qmsService.activity.expectedToBeStartedOn) : new Date()
    }
  }

  allowEditing: boolean = false;
  editorName: string = '';
  editorTitle: string = '';
  editorValue: string = '';
  public openEditor(value: string, icon: string): void {

    const editorTitleMapping: Record<string, any> = {
      'Impact Description': this.dynamicLabel?.['IMPACT_DESCRIPTION']?.fieldName,
      'Description': this.dynamicLabel?.['DESCRIPTION']?.fieldName,
      'Investigation Summary': this.dynamicLabel?.['INVESTIGATION_SUMMARY']?.fieldName,
      'Occurrence Reason': this.dynamicLabel?.['OCCURANCE_REASON']?.fieldName,
      'Root Cause': this.dynamicLabel?.['ROOT_CAUSE']?.fieldName,
      'Final Impact Assessment': this.dynamicLabel?.['FINAL_IMPACT_ASSESSMENT']?.fieldName,
      'Conclusion': this.dynamicLabel?.['CONCLUSION']?.fieldName
    };


    this.allowEditing = icon == 'edit';
    this.editorName = value;
    this.editorTitle = editorTitleMapping[this.editorName];
    this.editorValue = this.qmsService.activity[this.getModel(value)];
    this.visibleEditor = this.dialog.open(this.editor, this.editorConfig);
  }

  public saveEditor(editorValue: any): void {
    this.qmsService.activity[this.getModel(this.editorName)] = this.editorValue;
    this.visibleEditor.close();
  }

  private getModel(value: string): any {
    return value.split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');
  }

  public cancelEditor(): void {
    this.visibleEditor.close();
  };

  config: EditorConfig = {
    buttons: [],
  };

  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  limitCharacters(event: Event, field: any) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: any = null;

    const fieldMapping: Record<number, string[]> = {
      400: ['REQUESTED_AT'],
      4000: ['REFERENCE_OTHERS', 'ASSESSMENT_COMMENT', 'CLOSURE_COMMENT', 'RESOLUTION_PROVIDED', 'TYPE_UPDATE_JUSTIFICATION'],
      1000: ['REQUESTED_AT']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = Number(limit);
        break;
      }
    }

    if (textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      target.value = target.value.substring(0, charLimit);
    }
  }

  handleDropDownValidation(fieldId: string, selectedItems: any[] | string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    const isMultiSelectValidation = (fieldId === 'business-area-validation' || fieldId === 'root-cause-type-validation');
    const shouldBeRed = isMultiSelectValidation ? !selectedItems.length : !selectedItems;

    field && (field.style.color = shouldBeRed ? 'red' : '#005c8a');
    !field && console.error('Unable to find the element. [handleDropDownValidation()] Id → ', fieldId);
  }

  onNgModelChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;

    field && (field.style.color = items ? '#005c8a' : 'red');
    !field && console.error('Unable to find the element. [onNgModuleChange()] Id → ', fieldId);
  }

  isContentEmpty(content: string): boolean {
    // Create a temporary element to parse the HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = content;

    // Get the text content and trim it
    const textContent = tempDiv.textContent ?? tempDiv.innerText ?? '';
    return textContent.trim().length === 0;
  }

  onStEditorChange(items: any, fieldId: string) {
    const field = document.getElementById(fieldId) as HTMLInputElement;
    let isEmpty: boolean = false;
    items && (isEmpty = this.isContentEmpty(items));
    field && (field.style.color = isEmpty ? 'red' : '#005c8a');
    !field && console.log('Unable to find the element. Id → ', fieldId);
  }

  fieldValidation(elementIds: string[]) {
    elementIds.forEach((elementId) => {
      const element = document.getElementById(elementId) as HTMLInputElement;

      element && (element.style.color = 'red');
      !element && console.error('Unable to find the element. [fieldValidation()] Id → ', elementId);
    });
  }

  private formatDate(date?: any): string | null {
    return date ? this.appService.dateZoneConvertion(new Date(date)) : null;
  }

  private mapBooleanToYN(value?: boolean): 'Y' | 'N' {
    return value ? 'Y' : 'N';
  }

  skipValidation: boolean = false;
  async update(): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      this.qmsService.validatedIncidentArray = [];
      let validationPromises: Promise<void>[] = [];
      const isInitiator = this.incidentData.initiator == this.message.getUserId();
      const isEvaluator = this.incidentData.evaluator == this.message.getUserId();
      const isInvestigator = this.incidentData.investigator == this.message.getUserId();
      const status = this.qmsService.activity.status;

      if (!this.skipValidationsWhileSwitchingUser && !this.skipValidation) {
        if (isInitiator && status == 'Draft' || status == 'More Information Requested By Evaluator') {
          validationPromises.push(this.validateIncidentDetails(), this.validateIncidentDates());
        } else if (isEvaluator && (status == 'Evaluation Completed' || status == 'Logged' || status == 'Investigator Requested More Information' || status == 'Reviewer Requested More Info.' || status == 'Review Rejected' || status == 'Approver Requested More Info.' || status == 'Approval Rejected' || status == 'Closure Reviewer Requested More Info.' || status == 'Closure Review Rejected' || status == 'Closure Approver Requested More Info.' || status == 'Closure Approval Rejected')) {
          validationPromises.push(this.validateIncidentDetails(), this.validateIncidentDates(), this.validateIncidentLogs());
        } else if (isInvestigator && (status == 'Investigation Pending' || status == 'Reinvestigation Requested')) {
          validationPromises.push(this.validateIncidentInvestigation());
        } else if (isEvaluator && status == 'In Progress') {
          validationPromises.push(this.validateIncidentCompletion());
        }
      }

      Promise.all(validationPromises)
        .then(() => {
          const isValid = !this.qmsService.validatedIncidentArray.includes('Failed');
          if (isValid) {
            this.isProcessing = true;
            const data = {
              groupId: this.qmsService.activity.groupId,
              inNo: this.qmsService.activity.inNo,
              shortDescription: this.qmsService.activity.shortDescription,
              description: this.qmsService.activity.description,
              isOutsideOrganization: this.mapBooleanToYN(this.qmsService.activity.isOutsideOrganization),
              initiatedOnBehalf: (this.qmsService.activity.initiatedOnBehalfByOthers && this.qmsService.incidentDropDowns.selectedBehalfOfOthers) ? this.qmsService.incidentDropDowns.selectedBehalfOfOthers : null,
              inType: this.qmsService.incidentDropDowns.selectedIncidentType,
              deptCode: this.qmsService.incidentDropDowns.selectedDepartment,
              requestedAt: this.qmsService.incidentDropDowns.selectedRequestedAt,
              coreBusinessAreaName: this.isBusinessAreaEmpty ? this.qmsService.incidentDropDowns.selectedBusinessArea : this.qmsService.incidentDropDowns.selectedBusinessArea.join(','),
              reference: this.qmsService.incidentDropDowns.selectedReference,
              referenceOthers: this.qmsService.activity.referenceOthers,
              identifiedOn: this.formatDate(this.qmsService.activity.identifiedOn),
              groupReassignedOn: this.formatDate(this.qmsService.activity.groupReassignedOn),
              expectedToBeStartedOn: this.formatDate(this.qmsService.activity.expectedToBeStartedOn),
              startedOn: this.qmsService.activity.startedOn,
              expcetedClosureOn: this.formatDate(this.qmsService.activity.expcetedClosureOn),
              completedOn: this.formatDate(this.qmsService.activity.completedOn),
              actionItemsReqd: this.mapBooleanToYN(this.qmsService.activity.actionItemsReqd),
              preActionItemsReqd: this.mapBooleanToYN(this.qmsService.activity.preActionItemsReqd),
              effectivenessCheckReqd: this.mapBooleanToYN(this.qmsService.activity.effectivenessCheckReqd),
              impactType: this.qmsService.incidentDropDowns.selectedImpactType,
              impactDescription: this.qmsService.activity.impactDescription,
              evaluator: this.qmsService.incidentDropDowns.selectedEvaluator,
              assessmentComment: this.qmsService.activity.assessmentComment,
              investigator: this.qmsService.incidentDropDowns.selectedInvestigator,
              investigationRequired: this.mapBooleanToYN(this.qmsService.activity.investigationRequired),
              investigationSummary: this.qmsService.activity.investigationSummary,
              occurrenceReason: this.qmsService.activity.occurrenceReason,
              rootCauseType: this.qmsService.incidentDropDowns.selectedRootCauseType?.join(',') ?? null,
              rootCause: this.qmsService.activity.rootCause,
              conclusion: this.qmsService.activity.conclusion,
              finalImpactAssessment: this.qmsService.activity.finalImpactAssessment,
              closureComment: this.qmsService.activity.closureComment,
              resolutionProvided: this.qmsService.activity.resolutionProvided,
              resolutionCategory: this.qmsService.incidentDropDowns.selectedResolutionCategory,
              raisedFrom: "Manage",
              isRiskCalculationReqd: this.mapBooleanToYN(this.qmsService.activity.isRiskCalculationReqd),
              usersToBeIntimatedPostEvaluation: this.mapBooleanToYN(this.qmsService.activity.usersToBeIntimatedPostEvaluation),
              typeUpdateJustification: this.qmsService.activity.typeUpdateJustification,

              /*prioritization: */
            }
            this.appService.updateIncident(data).subscribe({
              next: (Response: any) => {
                if (Response.resultType === 'S') {
                  this.ngOnInit();
                  if (this.skipValidationsWhileSwitchingUser) {
                    this.skipValidationsWhileSwitchingUser = false;
                  } else if (this.flexibleComponent.flexibleFields.length) {
                    this.flexibleComponent.save('activity', this.qmsService.activityId);
                  }

                  if (this.qmsService.isUpdatingIncidentThroughDynBtn) {
                    this.qmsService.isUpdatingIncidentThroughDynBtn = false;
                  } else {
                    this.showSnackBar(Response.result, Response.resultType);
                  }

                  resolve(true);
                }
                this.isProcessing = false;
              },
              error: (error: Error) => {
                this.isProcessing = false;
                throw error;
              }
            })
          } else {
            this.visibleMandatoryPopup = this.dialog.open(this.mandatoryPopup, this.mandatoryPopupConfig);
          }
        }).catch((error) => {
          console.error('Error occurred during validation:', error);
          resolve(false);
        })
    })
  }

  async validateIncidentDetails(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.incidentDropDowns.selectedIncidentType, id: 'in-type-validation' },
      { condition: this.dynamicLabel['DEPT_NAME'].isRemovable != 'Y' && !this.qmsService.incidentDropDowns.selectedDepartment, id: 'department-validation' },
      { condition: !this.qmsService.incidentDropDowns.selectedReference, id: 'reference-validation' },
      this.qmsService.incidentDropDowns.selectedReference && { condition: this.qmsService.incidentDropDowns.selectedReference.toLowerCase() === 'others' && !this.qmsService.activity.referenceOthers, id: 'reference-others-validation' },
      { condition: !this.qmsService.incidentDropDowns.selectedRequestedAt, id: 'requested-at-validation' },
      { condition: this.isBusinessAreaEmpty ? !this.qmsService.incidentDropDowns.selectedBusinessArea : !this.qmsService.incidentDropDowns.selectedBusinessArea.length, id: 'business-area-validation' },
      { condition: !this.qmsService.incidentDropDowns.selectedImpactType, id: 'impact-type-validation' },
      { condition: !this.qmsService.activity.impactDescription || this.isContentEmpty(this.qmsService.activity.impactDescription), id: 'impact-description-validation' },
      { condition: !this.qmsService.activity.shortDescription, id: 'short-description-validation' },
      { condition: !this.qmsService.activity.description || this.isContentEmpty(this.qmsService.activity.description), id: 'description-validation' },
      { condition: this.qmsService.activity.initiatedOnBehalfByOthers && !this.qmsService.incidentDropDowns.selectedBehalfOfOthers, id: 'behalf-of-others-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateIncidentDates(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.activity.identifiedOn, id: 'identified-on-validation' },
      { condition: this.dynamicLabel['EXPECTED_TO_BE_STARTED_ON'].isRemovable != 'Y' && !this.qmsService.activity.expectedToBeStartedOn, id: 'expected-to-be-started-on-validation' },
      { condition: !this.qmsService.activity.expcetedClosureOn, id: 'expected-closure-on-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateIncidentLogs(): Promise<void> {
    const validations = [
      { condition: this.dynamicLabel['ASSESSMENT_COMMENT'].isRemovable != 'Y' && !this.qmsService.activity.assessmentComment, id: 'assessment-comments-validation' },
      { condition: this.qmsService.activity.investigationRequired && !this.qmsService.incidentDropDowns.selectedInvestigator, id: 'investigator-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  async validateIncidentInvestigation(): Promise<void> {
    const validations = [
      { condition: this.dynamicLabel['INVESTIGATION_SUMMARY'].isRemovable != 'Y' && (!this.qmsService.activity.investigationSummary || this.isContentEmpty(this.qmsService.activity.investigationSummary)), id: 'investigation-summary-validation' },
      { condition: this.dynamicLabel['OCCURANCE_REASON'].isRemovable != 'Y' && (!this.qmsService.activity.occurrenceReason || this.isContentEmpty(this.qmsService.activity.occurrenceReason)), id: 'occurrence-reason-validation' },
      { condition: this.dynamicLabel['ROOT_CAUSE'].isRemovable != 'Y' && (!this.qmsService.activity.rootCause || this.isContentEmpty(this.qmsService.activity.rootCause)), id: 'root-cause-validation' },
      { condition: this.dynamicLabel['ROOT_CAUSE_TYPE'].isRemovable != 'Y' && !this.qmsService.incidentDropDowns.selectedRootCauseType.length, id: 'root-cause-type-validation' },
      { condition: this.dynamicLabel['FINAL_IMPACT_ASSESSMENT'].isRemovable != 'Y' && (!this.qmsService.activity.finalImpactAssessment || this.isContentEmpty(this.qmsService.activity.finalImpactAssessment)), id: 'final-impact-validation' },
      { condition: this.dynamicLabel['CONCLUSION'].isRemovable != 'Y' && (!this.qmsService.activity.conclusion || this.isContentEmpty(this.qmsService.activity.conclusion)), id: 'conclusion-validation' },
    ];
    await this.handleAsyncValidation(validations);
  }

  async validateIncidentCompletion(): Promise<void> {
    const validations = [
      { condition: !this.qmsService.incidentDropDowns.selectedResolutionCategory, id: 'resolution-category-validation' },
      { condition: this.dynamicLabel['RESOLUTION_PROVIDED'].isRemovable != 'Y' && !this.qmsService.activity.resolutionProvided, id: 'resolution-provided-validation' },
      { condition: this.dynamicLabel['CLOSURE_COMMENT'].isRemovable != 'Y' && !this.qmsService.activity.closureComment, id: 'closure-comment-validation' },
    ]
    await this.handleAsyncValidation(validations);
  }

  private async handleAsyncValidation(validations: { condition: boolean, id: string }[]): Promise<void> {
    const invalidIds: string[] = validations.filter(v => v.condition).map(v => v.id);
    this.qmsService.validatedIncidentArray.push(invalidIds.length > 0 ? 'Failed' : 'Passed');
    console.log(this.qmsService.validatedIncidentArray, "Array")
    if (invalidIds.length > 0) {
      this.selectedTabIndex = 0;
      this.fieldValidation(invalidIds);
    }
  }

  scrollToMasdatoryField: any;
  scrollToMandatoriesField(value: any) {
    this.scrollToMasdatoryField = document.getElementById(value) as HTMLInputElement;
    setTimeout(() => this.scrollToMasdatoryField.scrollIntoView(), 0);
  }

  taskStageUsers: any = [];
  getStageUsers() {
    const statusMap: { [key: string]: string } = {
      'Pending Review': 'Review', 'Review Inprogress': 'Review', 'Pending Approval': 'Approve', 'Approval Inprogress': 'Approve'
    };

    const stageName = statusMap[this.incidentData.status] || '';

    if (stageName) {
      this.appService.getTaskStageUsers(this.incidentData.inNo, 0, stageName).subscribe((stageUser: any) => {
        this.taskStageUsers = stageUser.filter((user: any) => user.status && user.status != 'Review Completed' && user.status != 'Approval Completed');
        this.setIncidentAesthetic();
      });
    } else {
      this.setIncidentAesthetic();
    }
  }

  checkEcHasData() {
    this.appService.getQmsTasksEC(this.qmsService.activityId).subscribe((data: any) => {
      this.message.showEffectiveSection = data.length ?? this.qmsService.activity.effectivenessCheckReqd;
    })
  }

  isEvaluatorUsersLock: boolean = false;
  isInvestigatorUserLock: boolean = false;
  setIncidentAesthetic() {
    const status = this.qmsService.activity.status;
    const loggedUserId = +this.message.getUserId();
    const isInitiator = this.qmsService.activity.initiator == loggedUserId;
    const isEvaluator = this.qmsService.activity.evaluator == loggedUserId;
    const isInvestigator = this.qmsService.activity.investigator == loggedUserId;
    const isEditableByInvestigator = this.qmsService.selectedGroupDetailData.editableByInvestigator == "Y";
    const isInvestigation = this.qmsService.activity.investigationRequired;
    const isActions = this.qmsService.activity.actionItemsReqd;
    const isPreActions = this.qmsService.activity.preActionItemsReqd;
    const isRisk = this.qmsService.activity.isRiskCalculationReqd && this.qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y';
    const isReviewer = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByReviewer = this.qmsService.selectedGroupDetailData.editableByReviewers == "Y";
    const isApprover = this.taskStageUsers.some((user: any) => user.taskStageUsersPk.userId == loggedUserId);
    const isEditableByApprover = this.qmsService.selectedGroupDetailData.editableByApprovers == "Y";

    this.isEvaluatorUsersLock = true;
    this.isInvestigatorUserLock = true;

    if (status == "Draft") {
      this.isEvaluatorUsersLock = !isInitiator;
      this.message.showInSaveButton = isInitiator;
      this.isDetailSectionFrozen = !isInitiator;
      this.isDateSectionFrozen = !isInitiator;
      this.message.showIncidentLoggingSections = false;
      this.message.showInvestigationSection = false;
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isInitiator;
      this.message.showActionSection = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isInitiator;
      this.message.showDependancySection = false;
      this.message.showReviewApproveSection = false;
      this.message.showExtensionSection = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isInitiator;
    } else if (status == "Raised" || status == "Evaluation Rejected - Closed" || status == "Deleted") {
      this.message.showInSaveButton = false;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = false;
      this.message.showInvestigationSection = false;
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = false;
      this.message.showDependancySection = false;
      this.message.showReviewApproveSection = false;
      this.message.showExtensionSection = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Evaluation Completed" || status == "Logged") {
      this.isInvestigatorUserLock = !isEvaluator;
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = !isEvaluator;
      this.isDateSectionFrozen = !isEvaluator;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = !isEvaluator;
      this.message.showInvestigationSection = false;
      this.message.showCompleteIncidentSections = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Investigator Requested More Information") {
      this.isInvestigatorUserLock = !isEvaluator;
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = !isEvaluator;
      this.message.showInvestigationSection = true;
      this.isInvestigationSectionFrozen = true;
      this.message.showCompleteIncidentSections = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Investigation Pending" || status == "Reinvestigation Requested") {
      this.message.showInSaveButton = isInvestigator;
      this.isDetailSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.isDateSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = !(isInvestigator && isEditableByInvestigator);
      this.message.showInvestigationSection = isInvestigator;
      this.isInvestigationSectionFrozen = !isInvestigator;
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isInvestigator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isInvestigator && isEditableByInvestigator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isInvestigator && isEditableByInvestigator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isInvestigator && isEditableByInvestigator;
    } else if (status == "Investigation Completed") {
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = true;
      this.isInvestigationSectionFrozen = true;
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "Pending Review" || status == "Review Inprogress") {
      this.message.showInSaveButton = false;
      this.isDetailSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.isDateSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = !(isReviewer && isEditableByReviewer);
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isReviewer && isEditableByReviewer;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isReviewer && isEditableByReviewer;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isReviewer || isApprover;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isReviewer && isEditableByReviewer;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isReviewer && isEditableByReviewer;
    } else if (status == "Pending Approval" || status == "Approval Inprogress") {
      this.message.showInSaveButton = false;
      this.isDetailSectionFrozen = !(isApprover && isEditableByApprover);
      this.isDateSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = !(isApprover && isEditableByApprover);
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isApprover && isEditableByApprover;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isApprover && isEditableByApprover;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isReviewer || isApprover;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isApprover && isEditableByApprover;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isApprover && isEditableByApprover;
    } else if (status == "Reviewer Requested More Info." || status == "Review Rejected" || status == "Approver Requested More Info." || status == "Approval Rejected") {
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteIncidentSections = false;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = false;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    } else if (status == "In Progress") {
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteIncidentSections = true;
      this.isCompleteSectionFrozen = !isEvaluator;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Pending Closure Review" || status == "Closure Review Inprogress" || status == "Pending Closure Approval" || status == "Closure Approval Inprogress" || status == "Closed") {
      this.message.showInSaveButton = false;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteIncidentSections = true;
      this.isCompleteSectionFrozen = true;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = false;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = false;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = status == "Closed" && isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = false;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = false;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = false;
    } else if (status == "Closure Reviewer Requested More Info." || status == "Closure Review Rejected" || status == "Closure Approver Requested More Info." || status == "Closure Approval Rejected") {
      this.message.showInSaveButton = isEvaluator;
      this.isDetailSectionFrozen = true;
      this.isDateSectionFrozen = true;
      this.message.showIncidentLoggingSections = true;
      this.isLoggingSectionFrozen = true;
      this.message.showInvestigationSection = isInvestigation;
      this.isInvestigationSectionFrozen = isInvestigation;
      this.message.showCompleteIncidentSections = true;
      this.isCompleteSectionFrozen = true;
      this.message.showPreActionsTab = isPreActions;
      this.message.showPreActionsActionButtons = isEvaluator;
      this.message.showActionSection = isActions;
      this.message.showActionsActionButtons = isEvaluator;
      this.message.showDocumentSection = true;
      this.message.showDocumentActionButtons = isEvaluator;
      this.message.showDependancySection = true;
      this.message.showDependencyActionButton = isEvaluator;
      this.message.showExtensionSection = true;
      this.message.showReviewApproveSection = true;
      this.message.showReviewApproveActionButtons = isEvaluator;
      this.message.showRiskTab = isRisk;
      this.qmsService.showRiskButtons = isEvaluator;
    }

    this.message.showEffectiveActionButtons = status == "Closed" && ((this.qmsService.userRole[0].qmsRoles.includes("Effectiveness Check Performer") && this.qmsService.userRole.length > 0) || isEvaluator);
    this.elite_Action_EC_Risk = isEvaluator && (status == "Investigation Completed" || status == "Reviewer Requested More Info." || status == "Review Rejected" || status == "Approver Requested More Info." || status == "Approval Rejected" || status == "Closure Reviewer Requested More Info." || status == "Closure Review Rejected" || status == "Closure Approver Requested More Info." || status == "Closure Approval Rejected" || status == "Investigator Requested More Information");
    this.qmsService.elite_AccessToClosure_Reviewer_Approver = status == "In Progress" && isEvaluator;
    setTimeout(() => { this.setUpdateType(status) }, 1500);
    setTimeout(() => { this.flexibleComponent.main() });
  }

  setSwitchUserAesthetic(status: any, user: string): boolean {

    if (user == "evaluator") {
      this.qmsService.validSwitchStatus = status != 'Evaluation Rejected - Closed';
      return this.qmsService.validSwitchStatus;
    } else {
      this.qmsService.validSwitchStatus = status != 'Evaluation Rejected - Closed' && status != 'Closed'
      return this.qmsService.validSwitchStatus
    };
  }

  showUpdateType: boolean = false;
  private setUpdateType(status: string): void {

    const statuses = new Set([
      'Draft',
      'More Information Requested By Evaluator',
      'Raised',
      'Evaluation Completed',
      'Evaluation Rejected - Closed',
    ]);

    this.showUpdateType = !statuses.has(status);
  }

  @ViewChild('topicPopup', { static: true }) topicPopup: TemplateRef<any>;
  visibleTopicPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('taskActiomHistoryPopup', { static: true }) taskActionHistoryPopup: TemplateRef<any>;
  visibleTaskActiosHistoryPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('openExportReportPopup', { static: true }) openExportReportPopup: TemplateRef<any>;
  visibleExportReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('mandatoryPopup', { static: true }) mandatoryPopup: TemplateRef<any>;
  visibleMandatoryPopup: MatDialogRef<TemplateRef<any>>;

  topicPopupConfig = {
    width: '130%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  taskActionHistoryPopupConfig = {
    width: '130%',
    height: '100%',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
    maxWidth: '95vw',
  };

  exportReportPopupConfig = {
    width: '35%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  mandatoryPopupConfig = {
    width: '400px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  openTopicPopup() {
    this.message.communicatingFrom = this.qmsService.moduleName;
    this.visibleTopicPopup = this.dialog.open(this.topicPopup, this.topicPopupConfig);
  }

  cancelTopicPopup() {
    this.visibleTopicPopup.close();
  }

  openTaskActionsHistory() {
    this.taskActionsHistoryComponent.ngOnInit();
    this.visibleTaskActiosHistoryPopup = this.dialog.open(this.taskActionHistoryPopup, this.taskActionHistoryPopupConfig);
  }

  cancelTaskActiosHistoryPopup() {
    this.visibleTaskActiosHistoryPopup.close();
  }

  //PDF report code start

  selectBoxForReportTemplate() {
    this.reportTemplateDropdown = [];
    this.reportTemplateDropdown = this.dropDownDataForReportTemplate?.map((item: any) => ({
      valueExp: item.qmsReportTemplateVwPk.templateId,
      displayExp: item.templateName
    }))
  }

  templateid: number;
  // onReportTemplateSelect(item: any) {
  //
  //   this.templateid = item.valueExp;
  //   if (this.reportTemplateFieldValidation != undefined) {
  //     this.reportTemplateFieldValidation.style.color = '';
  //   }
  // }
  onPdfDetailValueSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.templateid = item;
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = '#005c8a';
      }

    }
  }
  onReportTemplateRemoved(item: any) {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (!this.selectedReportTemplateValue) {
      if (this.reportTemplateFieldValidation != undefined) {
        this.reportTemplateFieldValidation.style.color = 'red';
      }
    }
  };
  openExportPopup() {
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExportReportPopup = this.dialog.open(this.openExportReportPopup, this.exportReportPopupConfig);
  }
  cancelExportPopup() {
    this.visibleExportReportPopup.close();
  }

  reportTemplateFieldValidation: any;
  generateReport() {
    this.reportTemplateFieldValidation = document.getElementById('reportTemplate-validation') as HTMLInputElement;
    if (this.selectedReportTemplateValue) {
      let data1: any = {};

      this.incidentData.templateId = 17337;
      let y: number = +this.message.getUserId();
      this.incidentData.userId = y

      let thirdL = this.message.breadcrumbData.secondLevel.split('>');
      data1 = {
        "groupId": this.qmsService.activity.groupId + "",
        "gridName": "IN",
        "templateId": this.selectedReportTemplateValue,
        "logoId": this.selectedReportLogoValue ?? null,
        "isSaveRep": this.isSaveReport ? 'Y' : 'N',
        "attachAllDocuments": this.attachAllDocuments ? 'Y' : 'N',
        "footer": this.selectedReportFooter ?? null,
        "reportName": this.reportName ?? "IN_Report",
        "currentStatus": this.qmsService.activity.status,
        "groupName": thirdL[1],
        "INid": this.message.activityId,
        "version": "0",
        "INId": this.qmsService.activity.inId

      }
      this.isProcessing = true;
      this.appService.genRateINReport(data1).subscribe((response: any) => {

        const blob = new Blob([response.body], { type: "application/pdf" });
        let downloadURL = globalThis.URL.createObjectURL(blob);
        let link = document.createElement('a');
        link.href = downloadURL;
        const firstst = this.message.breadcrumbData.firstLevel;
        const secondnd = this.message.breadcrumbData.secondLevel;
        const thirdL = this.message.breadcrumbData.thirdLevel;
        const fourthL = this.message.breadcrumbData.fourthLevel;

        let fileName = "";
        if (firstst != null) {
          fileName = firstst + "_";
        }
        if (secondnd != null) {
          fileName = fileName + secondnd + "_";
        }
        if (thirdL != null) {
          fileName = fileName + thirdL + "_";
        }
        if (fourthL != null) {
          fileName = fileName + fourthL + "_";
        }
        link.download = fileName + Date.now() + ".pdf";
        link.click();
        this.isProcessing = false;
      })
    } else {
      alert('Please enter the all mandatory fields...');
      this.reportTemplateFieldValidation.style.color = 'red';
    }
  }

  cancelReport() {
    this.visibleExportReportPopup.close();
  }
  //PDF report code end

  closeMandatoryPopup() {
    this.visibleMandatoryPopup.close();
  }

  lockActivity(): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // strip time

    const closureDate = new Date(this.qmsService.activity.expcetedClosureOn);
    closureDate.setHours(0, 0, 0, 0);

    if (today > closureDate && this.qmsService.selectedGroupDetailData?.isExtensionRequired == 'Y') {
      setTimeout(() => {
        this.showSnackBar("The activity closure date has passed. Please extend the date to proceed!", 'E');
      }, 100);
      return true;
    } else {
      return false;
    }
  }

  @ViewChild(SwitchuserComponent) switchuserComponent!: SwitchuserComponent;
  /* Note : if userBeingSwitched param values changed then regarding names need to changed in SwitchuserComponent too */
  async openSwitchUser(userBeingSwitched: any) {
    if (this.qmsService.activity.status == "In Progress" && userBeingSwitched != "Evaluator" && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {
      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
      return;
    } else { this.isProcessing = false; }
    this.message.switchedUser = [];
    this.message.switchUserdropDownList = [];
    this.message.submodule = null;
    this.message.switchuserRole = userBeingSwitched;
    if (userBeingSwitched == "Evaluator") {
      this.message.switchedUser = this.qmsService.incidentDropDowns.selectedEvaluator;
      this.message.switchUserCurrentValue = this.qmsService.incidentDropDowns.selectedEvaluator;
      this.message.switchUserdropDownList = this.evaluatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    } else if (userBeingSwitched == "Investigator") {
      this.message.switchedUser = this.qmsService.incidentDropDowns.selectedInvestigator;
      this.message.switchUserCurrentValue = this.qmsService.incidentDropDowns.selectedInvestigator;
      this.message.switchUserdropDownList = this.investigatorDropDown.map((item: any) => ({
        valueExp: item.valueExp,
        displayExp: item.displayExp
      })) ?? []
    }
    this.switchuserComponent.openswitchuser(userBeingSwitched, "IN");
  }

  onChildValueEmitted() {
    if (this.message.switchuserRole == "Evaluator") {
      this.qmsService.incidentDropDowns.selectedEvaluator = this.message.switchedUser;
    } else if (this.message.switchuserRole == "Investigator") {
      this.qmsService.incidentDropDowns.selectedInvestigator = this.message.switchedUser;
    }
    this.skipValidationsWhileSwitchingUser = true;
    this.switchuserComponent.saveMethod();
    this.update();
    this.switchuserComponent.visibleswitchUserPopup.close();
    this.switchuserComponent.visibleConfirmationPopup.close();
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    this.snackbarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel,
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackbarRef.onAction().subscribe(() => {
      this.snackbarRef.dismiss();
    });
  }

  addworkflow: boolean = false;
  parallelWorkflowList: any = [];
  async openAddWorkflow() {
    if (this.qmsService.activity.status == "In Progress" && await this.qmsService.validateExtension({ refNo: this.qmsService.activityId, extensionFor: "Activity" })) {

      setTimeout(() => {
        this.showSnackBar(this.qmsService.extensionResult, 'E');
      }, 0);
      this.isProcessing = false;
    } else this.addworkflow = true;
    this.isProcessing = false;
  };

  onworkflowChildValueEmitted() {
    this.parallelWorkflowList = null;
    this.appService.getWorkflowByRefNo(this.qmsService.activityId).subscribe((data: any) => {
      this.parallelWorkflowList = data;
    });
    this.addworkflow = false;
  }

  snackbarRef: any;
  ngAfterViewInit() {
    /* Listener for document click */
    this.clickListener = this.renderer.listen('document', 'click', () => {
      if (this.snackbarRef) {
        this.snackbarRef.dismiss();
      }
    });
  }

  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag() {
    let data = {
      pageName: 'Detail',
      labelName: "Tag",
      tagRef: this.incidentData.inId
    };
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };

  dropDownDataForReportLogo: any;
  selectedReportLogoValue: any = null;
  reportLogoFieldValidation: any;
  reportLogoDropdown: any = [];
  imageIdList: any = [];
  organizationReportImageDetails: any = {};
  logoVals: any;
  isSaveReport: boolean = false;
  reportName: any;
  onReportLogoValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.templateid = item;
      if (this.reportLogoFieldValidation != undefined) {
        this.reportLogoFieldValidation.style.color = '#005c8a';
      }
    }
  }

  selectBoxForReportLogoRefactored() {
    this.reportLogoDropdown = [];

    if (this.dropDownDataForReportLogo) {
      this.processReportImageList();
      this.setDefaultReportLogo();
    } else {
      this.selectedReportLogoValue = [];
    }
  }

  private processReportImageList() {
    const { reportImageList } = this.dropDownDataForReportLogo;

    if (reportImageList === 'Default') {
      this.addDefaultLogo();
    } else if (reportImageList.includes(',')) {
      this.processMultipleReportImages(reportImageList);
    } else {
      this.processSingleReportImage(reportImageList);
    }
  }

  private processMultipleReportImages(reportImageList: string) {
    this.imageIdList = reportImageList.split(',');

    this.imageIdList.forEach((id: any, index: any) => {
      if (index === 0 && id === 'Default') {
        this.addDefaultLogo();
      } else {
        this.addMatchingLogos(id);
      }
    });
  }

  private processSingleReportImage(reportImageList: string) {
    this.addMatchingLogos(reportImageList);
  }

  private addDefaultLogo() {
    this.reportLogoDropdown = [...this.reportLogoDropdown, { valueExp: 0, displayExp: 'Default' }];
  }

  private addMatchingLogos(id: string) {
    const matchingLogos = this.organizationReportImageDetails
      .filter((element: any) => element.reportImageId === id)
      .map((element: any) => ({
        valueExp: element.reportImageId,
        displayExp: element.reportImageName,
      }));

    this.reportLogoDropdown = [...this.reportLogoDropdown, ...matchingLogos];
  }

  private setDefaultReportLogo() {
    const { defaultReportName } = this.dropDownDataForReportLogo;

    if (defaultReportName !== 'Default' && defaultReportName !== null) {
      const selectedLogo = this.reportLogoDropdown.find((element: any) => element.valueExp === defaultReportName);
      this.selectedReportLogoValue = selectedLogo?.valueExp || null;
    } else {
      this.selectedReportLogoValue = this.reportLogoDropdown[0]?.valueExp || null;
    }
  }

  selectBoxForReportLogo() {
    this.reportLogoDropdown = [];
    if (this.dropDownDataForReportLogo) {
      console.log("this.dropDownDataForReportLogo=", this.dropDownDataForReportLogo);
      console.log("this.dropDownDataForReportLogo.reportImageList", this.dropDownDataForReportLogo.reportImageList);
      if (this.dropDownDataForReportLogo.reportImageList == 'Default') {
        this.reportLogoDropdown = this.reportLogoDropdown.concat({
          valueExp: 0,
          displayExp: 'Default'
        });
      } else if (this.dropDownDataForReportLogo.reportImageList.includes(",")) {
        this.imageIdList = this.dropDownDataForReportLogo.reportImageList.split(",");
        for (let i = 0; i < this.imageIdList.length; i++) {
          if (i == 0 && this.imageIdList[i] == 'Default') {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: 0,
              displayExp: 'Default'
            });
          } else {
            for (const element of this.organizationReportImageDetails) {
              if (element.reportImageId == this.imageIdList[i]) {
                this.reportLogoDropdown = this.reportLogoDropdown.concat({
                  valueExp: element.reportImageId,
                  displayExp: element.reportImageName
                });
              }
            }
          }
        }
      } else {
        for (const element of this.organizationReportImageDetails) {
          if (element.reportImageId == this.dropDownDataForReportLogo.reportImageList) {
            this.reportLogoDropdown = this.reportLogoDropdown.concat({
              valueExp: element.reportImageId,
              displayExp: element.reportImageName
            });
          }
        }
      }
      if (this.dropDownDataForReportLogo.defaultReportName != 'Default' && this.dropDownDataForReportLogo.defaultReportName != null) {
        for (const element of this.reportLogoDropdown) {
          if (element.valueExp == this.dropDownDataForReportLogo.defaultReportName) {
            this.selectedReportLogoValue = element.valueExp;
          }
        }
      } else {
        this.selectedReportLogoValue = this.reportLogoDropdown[0].valueExp;
      }
    } else {
      this.selectedReportLogoValue = [];
    }
  };

  navigateToRisk() {
    this.goToTabByLabel("Risk Assessment");
  }

  @ViewChild('tabsGroup', { static: false }) tabsGroup: MatTabGroup;
  set tabGroup(tabGroup: MatTabGroup) {
    if (tabGroup)
      setTimeout(() => { this.selectedTabIndex = tabGroup._tabs["_results"].find((t: any) => t.textLabel == this.selectedTabIndex).position; }, 0);
  }

  goToTabByLabel(label: string) {
    if (this.tabsGroup) {
      const tabs = (this.tabsGroup?._tabs as any)._results,
        match = tabs?.find((x: any) => x.textLabel?.toUpperCase() === label.toUpperCase());

      if (match) {
        this.tabsGroup.selectedIndex = match.position;
      }
    }
  }

  @ViewChild(ModuletypeComponent) moduleTypeComponent!: ModuletypeComponent;
  openModuleType: boolean = true;
  moduleTypeData: any;
  value: any;

  openUpdateType() {
    this.moduleTypeData = {
      dropdownList: this.incidentTypeDropdown,
      moduleTypeValue: this.qmsService.incidentDropDowns.selectedIncidentType,
      expcetedClosureOn: this.qmsService.activity.expcetedClosureOn,
      expectedToBeStartedOn: this.qmsService.activity.expectedToBeStartedOn,
      moduleName: this.dynamicLabel['IN_TYPE'].fieldName,
      moduleStartedOnName: this.dynamicLabel['STARTED_ON'].fieldName,
      moduleclosedOnName: this.dynamicLabel['COMPLETED_ON'].fieldName
    }
    this.openModuleType = true;
    this.moduleTypeComponent.openpopup(this.moduleTypeData); //
  }

  onModuleTypeEmitted($event: any) {
    this.openModuleType = false;
    this.qmsService.incidentDropDowns.selectedIncidentType = $event.moduleType;
    this.qmsService.activity.expcetedClosureOn = $event.expcetedClosureOn;
    this.qmsService.activity.expectedToBeStartedOn = $event.expectedToBeStartedOn;
    this.qmsService.activity.typeUpdateJustification = $event.typeUpdateJustification;
    this.skipValidation = true;
    this.update();
  }

  reportFooterfieldValidation1: any;
  selectedReportFooter: any;
  reportFooterDropdown1: any = [];
  reportFooterDropdown: any = [];
  onReportFooterSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (this.reportFooterfieldValidation1 != undefined) {
        this.reportFooterfieldValidation1.style.color = '#005c8a';
      }
    }
  }

  ngOnChangesReportFooter() {
    this.appService.getCodeListsByGroup("REPORT_FOOTER").subscribe({
      next: (data: any) => {
        this.reportFooterDropdown1 = data;

        this.selectBoxForFooter();
        if (this.reportFooterDropdown.length > 0) {
          this.selectedReportFooter = this.reportFooterDropdown[0].displayExp;
        }
      },
      error: (error: any) => {
        this.isProcessing = false;
      }
    });
  }

  selectBoxForFooter() {
    this.reportFooterDropdown = [];
    for (const vals of this.reportFooterDropdown1) {
      if (vals.moduleList == "Common" || vals.moduleList.includes(this.qmsService.moduleName)) {
        this.reportFooterDropdown.push({
          valueExp: vals.codelistName,
          displayExp: vals.codelistName
        });
      }
    }
  }

}
